import { ChartColumnIncreasingIcon } from 'lucide-react';

interface AnalysisContextBannerProps {
  /** Already translated: the namespace differs per surface, so callers own the copy. */
  label: string;
}

/**
 * States that the run is brand aware, and carries no control. Arriving from an analysis is the
 * intent, so there is nothing here to undo: a run with no brand context is started from the
 * tool's own page instead. Neutral rather than an alert, since this is the expected state.
 */
export const AnalysisContextBanner = ({ label }: AnalysisContextBannerProps) => (
  <div className="flex items-center gap-2 rounded-lg border border-border bg-muted px-3 py-2">
    <ChartColumnIncreasingIcon
      className="size-4 shrink-0 text-muted-foreground"
      aria-hidden="true"
    />
    <span className="text-sm text-foreground">{label}</span>
  </div>
);
